/**
 * Category scroll cue: hide the end-of-scroll gradient once the last item is reached.
 * Adds/removes .is-scrolled-end on the <theme-scroll> (styles in ada-compliance.css).
 */
(function () {
	var SECTION = '.section-collection-list-tabs theme-scroll';
	var THRESHOLD = 2; // px of tolerance for sub-pixel scroll positions

	function bind(ts) {
		if (ts.dataset.scrollCueBound) return;
		var scroller = ts.querySelector('.theme-scroll--inner');
		if (!scroller) return;
		ts.dataset.scrollCueBound = 'true';

		function update() {
			var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - THRESHOLD;
			ts.classList.toggle('is-scrolled-end', atEnd);
		}

		scroller.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
		if ('ResizeObserver' in window) new ResizeObserver(update).observe(scroller);
		update();
	}

	function init(root) {
		(root || document).querySelectorAll(SECTION).forEach(bind);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}

	// Theme editor: re-bind when the section is re-rendered
	document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/**
 * Quick View: on Searchanise result cards (collection / search pages), open the theme's own
 * Quick View (templates/product.quick-view) instead of Searchanise's modal, so every page
 * uses the same approved Quick View design.
 * Runs in the capture phase on window, before Searchanise's own click handler.
 */
(function () {
	var opener;

	function handleFromCard(button) {
		var card = button.closest('.snize-product');
		var link = card && card.querySelector('a[href*="/products/"]');
		var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
		return match ? decodeURIComponent(match[1]) : null;
	}

	window.addEventListener('click', function (event) {
		var button = event.target.closest && event.target.closest('.snize-quick-view-button');
		if (!button || !customElements.get('quick-view')) return; // fall back to Searchanise if the theme element is missing

		var handle = handleFromCard(button);
		if (!handle) return;

		event.preventDefault();
		event.stopImmediatePropagation();

		// Reuse the theme's <quick-view> element: it fetches ?view=quick-view and opens #Product-Modal
		if (!opener) {
			opener = document.createElement('quick-view');
			opener.hidden = true;
			document.body.appendChild(opener);
		}
		opener.dataset.productHandle = handle;
		opener.click();
	}, true);
})();

/**
 * "In stock" shipping-info tooltip (ⓘ).
 * app.js only binds the FIRST .shipping-info--button, and only on page load, so the tooltip
 * never opens inside the Quick View (its content is injected later). These delegated handlers
 * cover every button, including injected ones, and add keyboard support (Enter/Space, Escape).
 * The app.js-bound button stops propagation on click, so the two never double-toggle.
 */
(function () {
	var BUTTON = '.shipping-info--button';

	function popupOf(button) { return button.querySelector('.shipping-info--popup'); }
	function isOpen(button) { var popup = popupOf(button); return !!popup && popup.classList.contains('open'); }

	// Same open/close mechanics as app.js (class + inline opacity/visibility)
	function setOpen(button, open) {
		var popup = popupOf(button);
		if (!popup) return;
		popup.classList.toggle('open', open);
		popup.style.opacity = open ? 1 : 0;
		popup.style.visibility = open ? 'visible' : 'hidden';
		button.setAttribute('aria-expanded', open ? 'true' : 'false');
	}

	function closeAll(except) {
		document.querySelectorAll(BUTTON).forEach(function (button) {
			if (button !== except) setOpen(button, false);
		});
	}

	// Keyboard / screen-reader access to the icon
	function enhance(root) {
		(root || document).querySelectorAll(BUTTON).forEach(function (button) {
			if (button.hasAttribute('role')) return;
			button.setAttribute('role', 'button');
			button.setAttribute('tabindex', '0');
			button.setAttribute('aria-label', 'Shipping information');
			button.setAttribute('aria-expanded', 'false');
		});
	}

	document.addEventListener('click', function (event) {
		var button = event.target.closest && event.target.closest(BUTTON);
		if (!button) { closeAll(); return; }
		if (event.target.closest('.shipping-info--close')) { setOpen(button, false); return; }
		var popup = popupOf(button);
		if (popup && popup.contains(event.target)) return; // e.g. the "contact us" link
		var open = !isOpen(button);
		closeAll(button);
		setOpen(button, open);
	});

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') { closeAll(); return; }
		var button = event.target.closest && event.target.closest(BUTTON);
		if (button && event.target === button && (event.key === 'Enter' || event.key === ' ')) {
			event.preventDefault();
			setOpen(button, !isOpen(button));
		}
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { enhance(); });
	} else {
		enhance();
	}

	// The theme dispatches this on document after injecting the Quick View content
	document.addEventListener('quick-view:open', function () { enhance(document.getElementById('Product-Modal')); });
})();
